import { useMemo } from 'react';
import { useCollator } from '../i18n';
import { useSelectableCollection } from './useSelectableCollection';
import { ListKeyboardDelegate } from './ListKeyboardDelegate';
/**
 * Handles interactions with a selectable list.
 */ export function useSelectableList(props) {
    const { selectionManager, collection, disabledKeys, ref, keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    const collator = useCollator({
        usage: 'search',
        sensitivity: 'base'
    });
    const disabledBehavior = selectionManager.disabledBehavior;
    const delegate = useMemo(()=>keyboardDelegate || new ListKeyboardDelegate(collection, disabledBehavior === 'selection' ? new Set() : disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    const { collectionProps } = useSelectableCollection({
        ...props,
        ref,
        selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}

//# sourceMappingURL=useSelectableList.js.map